import { render, staticRenderFns } from "./TabHeaderComponent.vue?vue&type=template&id=1580c3ce&scoped=true&lang=pug"
import script from "./TabHeaderComponent.vue?vue&type=script&lang=ts"
export * from "./TabHeaderComponent.vue?vue&type=script&lang=ts"
import style0 from "./TabHeaderComponent.vue?vue&type=style&index=0&id=1580c3ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1580c3ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1580c3ce')) {
      api.createRecord('1580c3ce', component.options)
    } else {
      api.reload('1580c3ce', component.options)
    }
    module.hot.accept("./TabHeaderComponent.vue?vue&type=template&id=1580c3ce&scoped=true&lang=pug", function () {
      api.rerender('1580c3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabs/TabHeader/TabHeaderComponent.vue"
export default component.exports